import {
  FETCH_APPOINTMENTS_REQUEST,
  FETCH_APPOINTMENTS_SUCCESS,
  FETCH_APPOINTMENTS_FAILURE,
  UPDATE_APPOINTMENT,
  ADD_APPOINTMENT
} from './appointmentsActionTypes'

const initialState = {
  loading: false,
  appointments: [],
  error: ''
}

const appointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: ''
      }
    case FETCH_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        appointments: action.payload.results || action.payload,
        error: ''
      }
    case FETCH_APPOINTMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || action.payload
      }
    case UPDATE_APPOINTMENT:
      return {
        ...state,
        appointments: state.appointments.map(a =>
          a.id === action.payload.id ? { ...a, ...action.payload.changes } : a
        )
      }
    case ADD_APPOINTMENT:
      return {
        ...state,
        appointments: state.appointments.some(a => a.id === action.payload.id)
          ? state.appointments
          : [action.payload, ...state.appointments]
      }
    default:
      return state
  }
}

export default appointmentsReducer
